import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../../utils/services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Modal, overlayConfigFactory } from 'ngx-modialog';
import { NotificationsService } from 'angular2-notifications';
import { Organization } from '../../../utils/objects/organization';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import {PROVIDER_TYPES} from '../../../utils/constants/constants';

@Component({
  selector: 'app-parent-agency',
  templateUrl: './parent-agency.component.html',
  styleUrls: ['./parent-agency.component.scss']
})
export class ParentAgencyComponent implements OnInit {

  public readonly PROVIDER_TYPES = PROVIDER_TYPES;
  public agencies = [];
  private organizationID: number;
  public organization: Organization;
  public organizationAgencyID;
  public agencyAgencyControl: FormControl;
  public selectedCurrentAgency;
  public selectedCurrentAgencyCrossID;
  public organizationAgencyControl: FormControl;
  public isCurrentAgencySelected = false;
  public crossParameterForm: FormGroup;
  public depositForm: FormGroup;
  public oldFlightProviders = [];
  public oldHotelProviders = [];
  public oldRentingProviders = [];
  public oldPackageProviders = [];
  public currentProviders = [];
  public fproviders = [];
  public hproviders = [];
  public rproviders = [];
  public pproviders = [];
  public paymentTypeOnAccount;
  public paymentTypeCreditCard;
  public CreditCardFor3D;
  public isPaymentGateWayVisible = false;
  public paymentGateWay;
  public paymentGateways = [];
  public showPaymentGatewaysLoading = false;
  public paymentGatewaysLoadFailed = false;
  public isSelectedPaymentGatewayUndefined = false;
  public showLoading = false;
  public showProvidersLoading = false;
  public showOperationLoading = false;
  public showUseCompanyPrice;
  public showUseCompanyPriceExtraHotel;
  public showUseCompanyPriceModel = false;
  public showUseCompanyPriceExtraHotelModel = false;
  public crossParameters;
  public newItem;
  public balance;
  public cmproviders = [];
  public oldChannelManagerProviders = [];
  public acproviders = [];
  public oldAutocompleteProviders = [];

  constructor(public modal: Modal,
    private apiService: ApiService,
    private activatedRoute: ActivatedRoute,
    private notificationsService: NotificationsService,
    private router: Router) {
  }

  ngOnInit() {
    this.organizationAgencyControl = new FormControl(null, Validators.required);
    this.agencyAgencyControl = new FormControl(null, Validators.required);
    this.organization = this.activatedRoute.snapshot.parent.data.organizationData;
    this.getCrossOrgParams();
    this.getParentAgencies();
    this.agencyAgencyControl.valueChanges.subscribe(result => {
      if (result) {
        this.setSelectedAgency(this.agencyAgencyControl.value);
      } else {
        this.isCurrentAgencySelected = false
      }
    })

    this.depositForm = new FormGroup({
      'deposit': new FormControl(null,Validators.required)
    })

    this.crossParameterForm = new FormGroup({
      'paymentTypeOnAccount': new FormControl(false, Validators.required),
      'paymentTypeCreditCard': new FormControl(false, Validators.required),
      'paymentGateWay': new FormControl(null),
      'CreditCardFor3D': new FormControl({value:false, disabled: true}),
      'flightProvider': new FormControl(null),
      'hotelProvider': new FormControl(null),
      'rentingProvider': new FormControl(null),
      'packageProvider': new FormControl(null),
      'showUseCompanyPrice': new FormControl(null),
      'showUseCompanyPriceExtraHotel': new FormControl(null),
      'CurretProviders': new FormControl(null),
      'channelManagerProvider': new FormControl(null),
      'autocompleteProvider': new FormControl(null)
    });

    this.crossParameterForm.controls.paymentTypeCreditCard.valueChanges.subscribe(
      (value) => {
        this.isPaymentGateWayVisible = value;
        if (value) {
          this.crossParameterForm.controls.paymentGateWay.setValidators(Validators.required);
          this.crossParameterForm.controls.CreditCardFor3D.enable();
        } else {
          this.crossParameterForm.controls.CreditCardFor3D.disable();
          this.crossParameterForm.controls.paymentGateWay.setValidators(Validators.nullValidator);
        }
      }
    );
  }

  getDeposit(){
    this.apiService.getOrganizationDeposits(this.organization.id,this.selectedCurrentAgencyCrossID).subscribe(res=>{
      this.depositForm.controls.deposit.patchValue(res.data.rows[0].depositAmount)
      this.balance=res.data.rows[0].balanceAmount
    })
  }

  createDeposit(deposit){

    this.apiService.addDeposit(this.organization.id,this.selectedCurrentAgencyCrossID,deposit).subscribe(res=>{
      if(res.data){
        this.notificationsService.success(
          'Success',
          'Related agency is updated'
        );
      }
    })
  }

  getCrossOrgParams() {
    this.showOperationLoading = true;
    this.apiService.getOrganizationCrossParameters(this.organization.id).subscribe(
      response => {
        if (response['data']) {
          this.crossParameters = response['data'].crossParameter;
          this.currentProviders = [];
          this.crossParameters.forEach(crossParam => {
            if (crossParam.key === 'Provider') {
              this.currentProviders.push(crossParam);
              if (crossParam.context === "Flight") {
                this.oldFlightProviders.push(crossParam);
                this.crossParameterForm.controls.flightProvider.patchValue(this.oldFlightProviders ? this.oldFlightProviders[0].value : null);//NOTE: birden fazla provideri olursa sadece ilkini alir
              } else if (crossParam.context === "Hotel") {
                this.oldHotelProviders.push(crossParam);
                this.crossParameterForm.controls.hotelProvider.patchValue(this.oldHotelProviders ? this.oldHotelProviders[0].value : null);
              } else if (crossParam.context === "Renting") {
                this.oldRentingProviders.push(crossParam);
                this.crossParameterForm.controls.rentingProvider.patchValue(this.oldRentingProviders ? this.oldRentingProviders[0].value : null);
              }
              else if (crossParam.context === "Package") {
                this.oldPackageProviders.push(crossParam);
                this.crossParameterForm.controls.packageProvider.patchValue(this.oldPackageProviders ? this.oldPackageProviders[0].value : null);
              }
              else if (crossParam.context === "ChannelManager") {
                this.oldChannelManagerProviders.push(crossParam);
                this.crossParameterForm.controls.channelManagerProvider.patchValue(this.oldChannelManagerProviders ? this.oldChannelManagerProviders[0].value : null);
              }
              else if (crossParam.context === "AutoComplete") {
                this.oldAutocompleteProviders.push(crossParam);
                this.crossParameterForm.controls.autocompleteProdiver.patchValue(this.oldAutocompleteProviders ? this.oldAutocompleteProviders[0].value : null);
              }
            } else if (crossParam.key === 'ShowUseCompanyPrice') {
              this.currentProviders.push(crossParam);
              this.showUseCompanyPrice = crossParam;
              this.showUseCompanyPriceModel = (crossParam.value != 0) && (crossParam.value != 'false');
            } else if (crossParam.key === 'ShowUseCompanyPriceExtraHotel') {
              this.currentProviders.push(crossParam);
              this.showUseCompanyPriceExtraHotel = crossParam;
              this.showUseCompanyPriceExtraHotelModel = (crossParam.value != 0) && (crossParam.value != 'false');
            } else if (crossParam.key === 'PaymentType') {
              if (crossParam.value === 'OnAccount') {
                this.paymentTypeOnAccount = crossParam;
                this.crossParameterForm.controls.paymentTypeOnAccount.patchValue(!!this.paymentTypeOnAccount);
              } else if (crossParam.value === 'CreditCard') {
                this.paymentTypeCreditCard = crossParam;
                this.crossParameterForm.controls.paymentTypeCreditCard.patchValue(!!this.paymentTypeCreditCard);
              }else if (crossParam.value === 'CreditCardFor3D'){
                this.CreditCardFor3D = crossParam;
                this.crossParameterForm.controls.CreditCardFor3D.patchValue(!!this.CreditCardFor3D);

              }
            }else if (crossParam.key === 'DefaultPaymentGateway') {
              this.paymentGateWay = crossParam;
              this.crossParameterForm.controls.paymentGateWay.patchValue(this.paymentGateWay ? this.paymentGateWay.value : null);
              this.reconcileSelectedPaymentGateway();
            }
          });
          this.showOperationLoading = false;

        }
      }, err => {
        this.showOperationLoading = false;

      });
  }
  getParentAgencies() {
    this.showOperationLoading = true;
    this.organizationID = this.activatedRoute.snapshot.parent.params.id || this.organization.id;
    this.apiService.getCrossOrganizations(this.organizationID).subscribe(
      response => {
        this.agencies = response['data'].rows.filter(item => item.granteeOrganization).map(p => {
          this.newItem = p.granteeOrganization;

          this.newItem.crossID = p.id;

          return this.newItem
        });
        this.setSelectedAgency(this.newItem.name)
        this.showOperationLoading = false;

      }, error => {
        this.notificationsService.error(error);
        this.showOperationLoading = false;

      }

    );

  }

  mapCrossParameters() {
    this.paymentTypeOnAccount = null;
    this.paymentTypeCreditCard = null;
    this.paymentGateWay = null;
    this.oldFlightProviders = [];
    this.oldHotelProviders = [];
    this.showUseCompanyPrice = null;
    this.showUseCompanyPriceExtraHotel = null;
    this.showUseCompanyPriceModel = false;
    this.showUseCompanyPriceExtraHotelModel = false;
    this.crossParameters.forEach((crossParam) => {
      if (crossParam.crossOrganizationId === this.selectedCurrentAgencyCrossID) {
        this.setCrossParameterFields(crossParam)
      }
    });
    this.crossParameterForm.controls.paymentTypeOnAccount.patchValue(!!this.paymentTypeOnAccount);
    this.crossParameterForm.controls.paymentTypeCreditCard.patchValue(!!this.paymentTypeCreditCard);
    this.crossParameterForm.controls.CreditCardFor3D.patchValue(!!this.CreditCardFor3D);
    this.crossParameterForm.controls.paymentGateWay.patchValue(this.paymentGateWay ? this.paymentGateWay.value : null);
    this.crossParameterForm.controls.showUseCompanyPrice.patchValue(this.showUseCompanyPrice ? this.showUseCompanyPrice.value : null);
    this.crossParameterForm.controls.showUseCompanyPriceExtraHotel.patchValue(this.showUseCompanyPriceExtraHotel ? this.showUseCompanyPriceExtraHotel.value : null);

  }

  setCrossParameterFields(crossParam) {
    if (crossParam.key === 'PaymentType') {
      if (crossParam.value === 'OnAccount') {
        this.paymentTypeOnAccount = crossParam;
      } else if (crossParam.value === 'CreditCard') {
        this.paymentTypeCreditCard = crossParam;
      }
    } else if (crossParam.key === 'DefaultPaymentGateway') {
      this.paymentGateWay = crossParam;
    }
  }

  fetchAgencyProviders() {
    this.getDeposit()
    this.showProvidersLoading = true;
    this.fproviders = [];
    this.hproviders = [];
    this.rproviders = [];
    this.pproviders = [];
    this.cmproviders = [];
    this.acproviders = [];

    this.apiService.getOrganizationProviders(this.selectedCurrentAgency.id, `type_In=${PROVIDER_TYPES.join()}`).subscribe(res => {
      res.data.forEach(element => {
        if (element.type == 'FlightProvider') {
          this.fproviders.push(element.context);
        } else if (element.type == 'HotelProvider') {
          this.hproviders.push(element.context);
        } else if (element.type == 'RentingProvider') {
          this.rproviders.push(element.context);
        } else if (element.type == 'PackageProvider'){
          this.pproviders.push(element.context);
        } else if (element.type == 'ChannelManagerProvider') {
          this.cmproviders.push(element.context);
        } else if (element.type == 'AutocompleteProvider') {
          this.acproviders.push(element.context);
        }
      });
      this.showProvidersLoading = false;
    }, err => {
      this.showProvidersLoading = false;

    })
  }

  fetchAgencyPaymentGateways() {
    this.showPaymentGatewaysLoading = true;
    this.paymentGatewaysLoadFailed = false;
    this.apiService.getOrganizationProviders(this.selectedCurrentAgency.id, 'type_Eq=PaymentGateway').subscribe(res => {
      this.paymentGateways = (res.data || []).map(item => item.context);
      this.showPaymentGatewaysLoading = false;
      this.reconcileSelectedPaymentGateway();
    }, err => {
      this.paymentGateways = [];
      this.showPaymentGatewaysLoading = false;
      this.paymentGatewaysLoadFailed = true;
      this.reconcileSelectedPaymentGateway();
    });
  }

  reconcileSelectedPaymentGateway() {
    if (!this.crossParameterForm) {
      return;
    }
    const savedGateway = this.paymentGateWay ? this.paymentGateWay.value : null;
    this.isSelectedPaymentGatewayUndefined = false;
    if (savedGateway) {
      if (this.paymentGateways.indexOf(savedGateway) === -1) {
        this.paymentGateways = this.paymentGateways.concat([savedGateway]);
        this.isSelectedPaymentGatewayUndefined = !this.paymentGatewaysLoadFailed;
      }
      this.crossParameterForm.controls.paymentGateWay.patchValue(savedGateway);
    } else if (this.paymentGateways.length === 1) {
      this.crossParameterForm.controls.paymentGateWay.patchValue(this.paymentGateways[0]);
    }
  }

  insertAgency() {
    this.showOperationLoading = true;
    this.apiService.insertCrossOrganization(this.organization.id, this.organizationAgencyControl.value).subscribe(
      response => {
        this.organizationID = response['data'].id;
        this.organizationAgencyID = response['data'].granteeOrganizationId;
        this.notificationsService.success(
          'Success',
          'Related agency is updated'
        );
        this.getParentAgencies();
      },
      error => {
        this.showOperationLoading = false;
        // this.organizationAgencyControl.patchValue(
        //   this.organizationAgencyID ? this.organizationAgencyID : null
        // );
        if (error.error.code == 400606001) {
          this.notificationsService.warn('Warning', 'This agency already added as parent agency!');
        } else {
          this.notificationsService.error('Error', 'Error occured');
        }
      }
    );
  }

  //Current Agencies
  setSelectedAgency(item) {
    if (this.agencies.length) {
      let selectedParentName = item;
      if (selectedParentName) {
        this.isCurrentAgencySelected = true;
      }
      this.selectedCurrentAgency = this.agencies.find(agency => {
        return agency.name == selectedParentName;
      });

      this.selectedCurrentAgencyCrossID = this.selectedCurrentAgency.crossID;
      this.fetchAgencyProviders();
      this.fetchAgencyPaymentGateways();
    }


  }

  deleteAgency() {
    console.log('%c agency delete started', 'background: #222; color: #bada55')
    this.showOperationLoading = true;
    this.apiService.deleteCrossOrganization(this.organization.id, this.selectedCurrentAgencyCrossID).subscribe(
      response => {
        this.getParentAgencies();
        this.notificationsService.success(
          'Success',
          'Related agency is deleted'
        );
      },
      error => {
        this.showOperationLoading = false;

        this.organizationAgencyControl.patchValue(
          this.organizationAgencyID ? this.organizationAgencyID : null
        );
        this.notificationsService.error('Error', 'Error occured');
      }
    );
  }

  newAgencySelected() {
    // const selectedNewAgency = this.organizationAgencyControl.value;
    // if (selectedNewAgency) {
    //   this.isCurrentAgencySelected = true;
    // }

  }

  saveProvidersAndPaymentTypes() {

    this.showOperationLoading = true;
    if (this.crossParameterForm.controls.flightProvider.valid && this.crossParameterForm.controls.paymentTypeOnAccount.valid
      && this.crossParameterForm.controls.paymentTypeCreditCard.valid && this.crossParameterForm.controls.paymentGateWay.valid) {
      let requests: Array<Observable<any>> = [];

      /////////// PAYMENT TYPE
      //Payment Type OnAccount
      if (this.paymentTypeOnAccount) {
        if (!this.crossParameterForm.controls.paymentTypeOnAccount.value) {
          requests.push(
            this.apiService.deleteCrossParameter(this.organizationID, this.selectedCurrentAgencyCrossID, this.paymentTypeOnAccount.id));
        }
      } else {
        if (this.crossParameterForm.controls.paymentTypeOnAccount.value) {
          requests.push(this.apiService.postCrossParameter(this.organizationID, this.selectedCurrentAgencyCrossID, {
            context: 'Travel',
            key: 'PaymentType',
            value: 'OnAccount'
          }));
        }
      }
      if(this.CreditCardFor3D){
        if (!this.crossParameterForm.controls.CreditCardFor3D.value) {
          requests.push(
            this.apiService.deleteCrossParameter(this.organizationID, this.selectedCurrentAgencyCrossID, this.CreditCardFor3D.id)
          );
        }
      }else {
        if (this.crossParameterForm.controls.CreditCardFor3D.value) {
          requests.push(this.apiService.postCrossParameter(this.organizationID, this.selectedCurrentAgencyCrossID, {
            context: 'Travel',
            key: 'PaymentType',
            value: 'CreditCardFor3D'
          }));
        }
      }
      //Payment Type CreditCard
      if (this.paymentTypeCreditCard) {

        if (this.crossParameterForm.controls.paymentTypeCreditCard.value) {
          if (this.paymentGateWay) {
            requests.push(this.apiService.updateCrossParameter(this.organizationID, this.selectedCurrentAgencyCrossID, this.paymentGateWay.id, {
              value: this.crossParameterForm.controls.paymentGateWay.value
            }));
          } else {
            requests.push(this.apiService.postCrossParameter(this.organizationID, this.selectedCurrentAgencyCrossID, {
              context: 'Travel',
              key: 'DefaultPaymentGateway',
              value: this.crossParameterForm.controls.paymentGateWay.value
            }));
          }
        } else{
          requests.push(this.apiService.postCrossParameter(this.organizationID, this.selectedCurrentAgencyCrossID, {
            context: 'Travel',
            key: 'PaymentType',
            value: 'CreditCard'
          }));
        }
        if (this.crossParameterForm.controls.paymentTypeCreditCard.value) {

        } else {
          requests.push(
            this.apiService.deleteCrossParameter(this.organizationID, this.selectedCurrentAgencyCrossID, this.paymentTypeCreditCard.id)
          );
          if (this.paymentGateWay) {
            requests.push(
              this.apiService.deleteCrossParameter(this.organizationID, this.selectedCurrentAgencyCrossID, this.paymentGateWay.id)
            );
          }
        }
      } else {
        if (this.crossParameterForm.controls.paymentTypeCreditCard.value) {
          requests.push(this.apiService.postCrossParameter(this.organizationID, this.selectedCurrentAgencyCrossID, {
            context: 'Travel',
            key: 'PaymentType',
            value: 'CreditCard'
          }));
          requests.push(this.apiService.postCrossParameter(this.organizationID, this.selectedCurrentAgencyCrossID, {
            context: 'Travel',
            key: 'DefaultPaymentGateway',
            value: this.crossParameterForm.controls.paymentGateWay.value
          }));

        }
      }

      //Package secilmediyse ve Package secilse dahi eskiden olanlardan biriyle ayniysa hicbir sey yapma
      if (requests.length == 0)
        this.showOperationLoading = false;

      Observable.forkJoin(requests).subscribe(
        response => {
          this.notificationsService.success('Success', 'Cross parameter is updated');
          this.router.navigate(['./'], { relativeTo: this.activatedRoute });
          this.getCrossOrgParams();

        }, error => {
          this.notificationsService.error('Error', error.error.message);
          this.showOperationLoading = false;

        }
      );
    }

  }

  updateShowUseCompanyPrice(event) {
    let crossOrganizationId = this.currentProviders.find(item => item.value == 'bizihotel').crossOrganizationId;
    if (this.showUseCompanyPrice && this.showUseCompanyPrice.id) {
      this.showUseCompanyPrice.value = event;
      this.apiService.updateCrossParameter(this.organizationID, crossOrganizationId, this.showUseCompanyPrice.id, this.showUseCompanyPrice).subscribe(res => {
        this.notificationsService.success('Success', 'Parameter is updated successfully!');

      }, err => {
        this.notificationsService.error('Error', 'Operation failed!');
      })
    } else {
      if (event) {
        this.apiService.postCrossParameter(this.organizationID, crossOrganizationId, {
          context: 'Hotel',
          key: 'ShowUseCompanyPrice',
          value: true
        }).subscribe(res => {
          this.notificationsService.success('Success', 'Parameter is updated successfully!');
          this.showUseCompanyPrice = res.data;
        }, err => {
          this.notificationsService.error('Error', 'Operation failed!');

        });
      }

    }
  }

  updateShowUseCompanyPriceExtraHotel(event) {
    let crossOrganizationId = this.currentProviders.find(item => item.value == 'extrahotel').crossOrganizationId;
    if (this.showUseCompanyPriceExtraHotel && this.showUseCompanyPriceExtraHotel.id) {
      this.showUseCompanyPriceExtraHotel.value = event;
      this.apiService.updateCrossParameter(this.organizationID, crossOrganizationId, this.showUseCompanyPriceExtraHotel.id, this.showUseCompanyPriceExtraHotel).subscribe(res => {
        this.notificationsService.success('Success', 'Parameter is updated successfully!');

      }, err => {
        this.notificationsService.error('Error', 'Operation failed!');
      })
    } else {
      if (event) {
        this.apiService.postCrossParameter(this.organizationID, crossOrganizationId, {
          context: 'Hotel',
          key: 'ShowUseCompanyPriceExtraHotel',
          value: true
        }).subscribe(res => {
          this.notificationsService.success('Success', 'Parameter is updated successfully!');
          this.showUseCompanyPriceExtraHotel = res.data;
        }, err => {
          this.notificationsService.error('Error', 'Operation failed!');

        });
      }

    }
  }

  savePaymentTypes() {
    this.showOperationLoading = true;
    if (this.crossParameterForm.controls.paymentTypeOnAccount.valid && this.crossParameterForm.controls.paymentTypeCreditCard.valid && this.crossParameterForm.controls.paymentGateWay.valid) {
      let requests: Array<Observable<any>> = [];

      if (this.paymentTypeOnAccount) {
        if (!this.crossParameterForm.controls.paymentTypeOnAccount.value) {
          requests.push(
            this.apiService.deleteCrossParameter(this.selectedCurrentAgency.id, this.selectedCurrentAgencyCrossID, this.paymentTypeOnAccount.id));
        }
      } else {
        if (this.crossParameterForm.controls.paymentTypeOnAccount.value) {
          requests.push(this.apiService.postCrossParameter(this.selectedCurrentAgency.id, this.selectedCurrentAgencyCrossID, {
            context: 'Travel',
            key: 'PaymentType',
            value: 'OnAccount'
          }));
        }
      }
      /////////////////////////////////////////////////////
      if (this.paymentTypeCreditCard) {

        if (this.crossParameterForm.controls.paymentTypeCreditCard.value) {
          if (this.paymentGateWay) {
            requests.push(this.apiService.updateCrossParameter(this.selectedCurrentAgency.id, this.selectedCurrentAgencyCrossID, this.paymentGateWay.id, {
              value: this.crossParameterForm.controls.paymentGateWay.value
            }));
          } else {
            requests.push(this.apiService.postCrossParameter(this.selectedCurrentAgency.id, this.selectedCurrentAgencyCrossID, {
              context: 'Travel',
              key: 'DefaultPaymentGateway',
              value: this.crossParameterForm.controls.paymentGateWay.value
            }));
          }
        } else {
          requests.push(
            this.apiService.deleteCrossParameter(this.selectedCurrentAgency.id, this.selectedCurrentAgencyCrossID, this.paymentTypeCreditCard.id)
          );
          if (this.paymentGateWay) {
            requests.push(
              this.apiService.deleteCrossParameter(this.selectedCurrentAgency.id, this.selectedCurrentAgencyCrossID, this.paymentGateWay.id)
            );
          }
        }
      } else {
        if (this.crossParameterForm.controls.paymentTypeCreditCard.value) {
          requests.push(this.apiService.postCrossParameter(this.selectedCurrentAgency.id, this.selectedCurrentAgencyCrossID, {
            context: 'Travel',
            key: 'PaymentType',
            value: 'CreditCard'
          }));
          requests.push(this.apiService.postCrossParameter(this.selectedCurrentAgency.id, this.selectedCurrentAgencyCrossID, {
            context: 'Travel',
            key: 'DefaultPaymentGateway',
            value: this.crossParameterForm.controls.paymentGateWay.value
          }));

        }
      }
      if(this.CreditCardFor3D){
        if (!this.crossParameterForm.controls.CreditCardFor3D.value) {
          requests.push(
            this.apiService.deleteCrossParameter(this.organizationID, this.selectedCurrentAgencyCrossID, this.CreditCardFor3D.id)
          );
        }
      }else {
        if (this.crossParameterForm.controls.CreditCardFor3D.value) {
          requests.push(this.apiService.postCrossParameter(this.organizationID, this.selectedCurrentAgencyCrossID, {
            context: 'Travel',
            key: 'PaymentType',
            value: 'CreditCardFor3D'
          }));
        }
      }

      if (requests.length == 0)
        this.showOperationLoading = false;

      Observable.forkJoin(requests).subscribe(
        response => {
          this.getCrossOrgParams();
          this.notificationsService.success('Success', 'Cross parameter is updated');
          this.router.navigate(['./'], { relativeTo: this.activatedRoute });
          // this.router.navigate(['./'], { relativeTo: this.activatedRoute });
        }, error => {
          this.notificationsService.error('Error', 'Error occured');
          this.router.navigate(['./'], { relativeTo: this.activatedRoute });
          this.showOperationLoading = false;

        }
      );
    }
  }



  addHotelProvider() {
    //Hotel
    if (this.crossParameterForm.controls.hotelProvider.valid) {
      let requests = [];
      const selectedHotelProviderValue = this.crossParameterForm.controls.hotelProvider.value;
      if (selectedHotelProviderValue && this.hproviders.includes(selectedHotelProviderValue)) {//otel secildiyse
        var alreadyExist = false;
        this.oldHotelProviders.forEach(oldProvider => {
          if (oldProvider.value === selectedHotelProviderValue) {
            alreadyExist = true;//eski ucuslardan bir tanesi bile simdikiyle ayniysa
          }
        })
        if (!alreadyExist) {
          requests.push(this.apiService.postCrossParameter(this.selectedCurrentAgency.id, this.selectedCurrentAgencyCrossID, {
            context: 'Hotel',
            key: 'Provider',
            value: selectedHotelProviderValue
          }));
          if (selectedHotelProviderValue === 'bizihotel') {//secilen oten bizihotel ise showcompanypricei da gonder
            requests.push(this.apiService.postCrossParameter(this.selectedCurrentAgency.id, this.selectedCurrentAgencyCrossID, {
              context: 'Hotel',
              key: 'ShowUseCompanyPrice',
              value: this.crossParameterForm.controls.showUseCompanyPrice.value || false
            }));
          }
          if (selectedHotelProviderValue === 'extrahotel') {//secilen oten bizihotel ise showcompanypricei da gonder
            requests.push(this.apiService.postCrossParameter(this.selectedCurrentAgency.id, this.selectedCurrentAgencyCrossID, {
              context: 'Hotel',
              key: 'ShowUseCompanyPriceExtraHotel',
              value: this.crossParameterForm.controls.showUseCompanyPriceExtraHotel.value || false
            }));
          }
        } else {
          this.notificationsService.warn('Warning', 'This provider is already added!');
        }
      }
      //otel secilmediyse ve otel secilse dahi eskiden olanlardan biriyle ayniysa hicbir sey yapma
      Observable.forkJoin(requests).subscribe(
        response => {
          this.getCrossOrgParams();
          this.notificationsService.success('Success', 'Cross parameter is updated');
          this.router.navigate(['./'], { relativeTo: this.activatedRoute });
        }, error => {
          this.notificationsService.error('Error', error.error.message);
          this.router.navigate(['./'], { relativeTo: this.activatedRoute });
        }
      );
    }

  }

  addFlightProvider() {
    if (this.crossParameterForm.controls.flightProvider.valid) {
      //Flight
      const selectedFlightProviderValue = this.crossParameterForm.controls.flightProvider.value;
      if (selectedFlightProviderValue && this.fproviders.includes(selectedFlightProviderValue)) {//ucus secildiyse
        var alreadyExist = false;
        this.oldFlightProviders.forEach(oldProvider => {
          if (oldProvider.value === selectedFlightProviderValue) {
            alreadyExist = true;//eski ucuslardan bir tanesi bile simdikiyle ayniysa
          }
        })
        if (!alreadyExist) {//secilen ucus benzersiz ise
          //requests.push(this.apiService.deleteCrossParameter(this.selectedCurrentAgency.id, this.selectedCurrentAgencyCrossID, this.oldFlightProvider.id)); //eskiden silme kodu vardi, neden siliyoruz?
          let postData = {
            context: 'Flight',
            key: 'Provider',
            value: selectedFlightProviderValue
          }
          this.apiService.postCrossParameter(this.selectedCurrentAgency.id, this.selectedCurrentAgencyCrossID, postData).subscribe(
            response => {
              this.getCrossOrgParams();
              this.notificationsService.success('Success', 'Cross parameter is saved');
              this.router.navigate(['./'], { relativeTo: this.activatedRoute });
            }, error => {
              this.notificationsService.error('Error', error.error.message);
              this.router.navigate(['./'], { relativeTo: this.activatedRoute });
            }
          )
        } else {
          this.notificationsService.warn('Warning', 'This provider is already added!');
        }
        //ucus secilmediyse ve ucus secilse dahi eskiden olanlardan biriyle ayniysa hicbir sey yapma
      }
    }
  }

  addRentingProvider() {
    if (this.crossParameterForm.controls.rentingProvider.valid) {
      //Renting
      const selectedRentingProviderValue = this.crossParameterForm.controls.rentingProvider.value;
      if (selectedRentingProviderValue && this.rproviders.includes(selectedRentingProviderValue)) {
        var alreadyExist = false;
        this.oldRentingProviders.forEach(oldProvider => {
          if (oldProvider.value === selectedRentingProviderValue) {
            alreadyExist = true;
          }
        })
        if (!alreadyExist) {
          const postData = {
            context: 'Renting',
            key: 'Provider',
            value: selectedRentingProviderValue
          }
          this.apiService.postCrossParameter(this.selectedCurrentAgency.id, this.selectedCurrentAgencyCrossID, postData).subscribe(
            response => {
              this.getCrossOrgParams();
              this.notificationsService.success('Success', 'Cross parameter is saved');
              this.router.navigate(['./'], { relativeTo: this.activatedRoute });
            }, error => {
              this.notificationsService.error('Error', error.error.message);
              this.router.navigate(['./'], { relativeTo: this.activatedRoute });
            }
          )
        } else {
          this.notificationsService.warn('Warning', 'This provider is already added!');
        }
      }
    }
  }


  addPackageProvider() {
    if (this.crossParameterForm.controls.packageProvider.valid) {
      //Flight
      const selectedPackageProviderValue = this.crossParameterForm.controls.packageProvider.value;
      if (selectedPackageProviderValue && this.pproviders.includes(selectedPackageProviderValue)) {//ucus secildiyse
        var alreadyExist = false;
        this.oldPackageProviders.forEach(oldProvider => {
          if (oldProvider.value === selectedPackageProviderValue) {
            alreadyExist = true;//
          }
        })
        if (!alreadyExist) {
          let postData = {
            context: 'Package',
            key: 'Provider',
            value: selectedPackageProviderValue
          }
          this.apiService.postCrossParameter(this.selectedCurrentAgency.id, this.selectedCurrentAgencyCrossID, postData).subscribe(
            response => {
              this.getCrossOrgParams();
              this.notificationsService.success('Success', 'Cross parameter is saved');
              this.router.navigate(['./'], { relativeTo: this.activatedRoute });
            }, error => {
              this.notificationsService.error('Error', error.error.message);
              this.router.navigate(['./'], { relativeTo: this.activatedRoute });
            }
          )
        } else {
          this.notificationsService.warn('Warning', 'This provider is already added!');
        }
      }
    }
  }

  addChannelManagerProvider() {
    if (this.crossParameterForm.controls.channelManagerProvider.valid) {
      const selectedChannelManagerProviderValue = this.crossParameterForm.controls.channelManagerProvider.value;
      if (selectedChannelManagerProviderValue && this.cmproviders.includes(selectedChannelManagerProviderValue)) {
        let alreadyExist = false;
        this.oldChannelManagerProviders.forEach(oldProvider => {
          if (oldProvider.value === selectedChannelManagerProviderValue) {
            alreadyExist = true;//
          }
        })
        if (!alreadyExist) {
          let postData = {
            context: 'ChannelManager',
            key: 'Provider',
            value: selectedChannelManagerProviderValue
          }
          this.apiService.postCrossParameter(this.selectedCurrentAgency.id, this.selectedCurrentAgencyCrossID, postData).subscribe(
            response => {
              this.getCrossOrgParams();
              this.notificationsService.success('Success', 'Cross parameter is saved');
              this.router.navigate(['./'], { relativeTo: this.activatedRoute });
            }, error => {
              this.notificationsService.error('Error', error.error.message);
              this.router.navigate(['./'], { relativeTo: this.activatedRoute });
            }
          )
        } else {
          this.notificationsService.warn('Warning', 'This provider is already added!');
        }
      }
    }
  }

  addAutocompleteProvider() {
    if (this.crossParameterForm.controls.autocompleteProvider.valid) {
      const selectedAutocompleteProviderValue = this.crossParameterForm.controls.autocompleteProvider.value;
      if (selectedAutocompleteProviderValue && this.acproviders.includes(selectedAutocompleteProviderValue)) {
        let alreadyExist = false;
        this.oldAutocompleteProviders.forEach(oldProvider => {
          if (oldProvider.value === selectedAutocompleteProviderValue) {
            alreadyExist = true;//
          }
        })
        if (!alreadyExist) {
          let postData = {
            context: 'Autocomplete',
            key: 'Provider',
            value: selectedAutocompleteProviderValue
          }
          this.apiService.postCrossParameter(this.selectedCurrentAgency.id, this.selectedCurrentAgencyCrossID, postData).subscribe(
            response => {
              this.getCrossOrgParams();
              this.notificationsService.success('Success', 'Cross parameter is saved');
              this.router.navigate(['./'], { relativeTo: this.activatedRoute });
            }, error => {
              this.notificationsService.error('Error', error.error.message);
              this.router.navigate(['./'], { relativeTo: this.activatedRoute });
            }
          )
        } else {
          this.notificationsService.warn('Warning', 'This provider is already added!');
        }
      }
    }
  }

  deleteProvider(providerItem, providerIndex) {
    let requests = [];
    requests.push(this.apiService.deleteCrossOrganizationParameter(providerItem.id, this.organization.id, this.selectedCurrentAgencyCrossID));
    if (providerItem.value === 'bizihotel') {
      let showUseCompanyPrice = this.currentProviders.find(item => item.key === 'ShowUseCompanyPrice');
      if (showUseCompanyPrice)
        requests.push(this.apiService.deleteCrossOrganizationParameter(showUseCompanyPrice.id, this.organization.id, this.selectedCurrentAgencyCrossID));
    }
    if (providerItem.value === 'extrahotel') {
      let showUseCompanyPriceExtraHotel = this.currentProviders.find(item => item.key === 'ShowUseCompanyPriceExtraHotel');
      if (showUseCompanyPriceExtraHotel)
        requests.push(this.apiService.deleteCrossOrganizationParameter(showUseCompanyPriceExtraHotel.id, this.organization.id, this.selectedCurrentAgencyCrossID));
    }
    Observable.forkJoin(requests).subscribe(res => {
      this.notificationsService.success('Success', 'Delete operation is successful!');
      this.currentProviders.splice(providerIndex, 1);
      if (providerItem.context === 'Flight') {
        let itemIndex = this.oldFlightProviders.findIndex(item => item.id == providerItem.id);
        this.oldFlightProviders.splice(itemIndex, 1);
      }
      if (providerItem.context === 'Hotel') {
        let itemIndex = this.oldHotelProviders.findIndex(item => item.id == providerItem.id);
        this.oldHotelProviders.splice(itemIndex, 1);
        if (providerItem.value == 'bizihotel') {
          let showUseCompanyPriceIndex = this.currentProviders.findIndex(item => item.key == 'ShowUseCompanyPrice');
          if (showUseCompanyPriceIndex > -1)
            this.currentProviders.splice(showUseCompanyPriceIndex, 1);
        }
        if (providerItem.value == 'extrahotel') {
          let showUseCompanyPriceExtraHotelIndex = this.currentProviders.findIndex(item => item.key == 'ShowUseCompanyPriceExtraHotel');
          if (showUseCompanyPriceExtraHotelIndex > -1)
            this.currentProviders.splice(showUseCompanyPriceExtraHotelIndex, 1);
        }
      }
      if (providerItem.context === 'Package') {
        let itemIndex = this.oldPackageProviders.findIndex(item => item.id == providerItem.id);
        this.oldPackageProviders.splice(itemIndex, 1);
      }
      if (providerItem.context === 'ChannelManager') {
        let itemIndex = this.oldChannelManagerProviders.findIndex(item => item.id == providerItem.id);
        this.oldChannelManagerProviders.splice(itemIndex, 1);
      }
      if (providerItem.context === 'Autocomplete') {
        let itemIndex = this.oldAutocompleteProviders.findIndex(item => item.id == providerItem.id);
        this.oldAutocompleteProviders.splice(itemIndex, 1);
      }
      if (providerItem.context === 'Renting') {
        let itemIndex = this.oldRentingProviders.findIndex(item => item.id == providerItem.id);
        this.oldRentingProviders.splice(itemIndex, 1);
      }
    }), err => {
      this.notificationsService.error('Failed', 'Delete operation failed!');
    };
  }
}



// WEBPACK FOOTER //
// /var/www/bizisystem-frontend/src/src/app/main/frames/parent-agency/parent-agency.component.ts